import React from 'react';
import PropTypes from 'prop-types';

import { format } from 'inside-out/managers/dateManager';
import { Link } from 'inside-out/components/shared/link';

import AudienceIcon from '../../icons/audienceIcon';
import BookmarkIcon from '../../icons/bookmarkIcon';
import ViewsIcon from '../../icons/viewsIcon';
import {
	wrapperStyle,
	metaAudiencesStyle,
	wrapperCardStyle,
	wrapperLinkStyle,
	wrapperInnerStyle,
	bookmarkButtonStyle,
	metaBottomStyle,
	metaDateStyle,
	metaViewsStyle,
	titleStyle,
	bodyStyle,
} from './styles';

class ResourceCardComponent extends React.PureComponent {
	render() {
		const {
			type,
			to,
			audiences,
			title,
			body,
			date,
			views,
			hasVideo,
			background,
		} = this.props;

		/*
		TODO: Proper cascading styles with wrapperStyleWithBackground parent
		*/
		return (
			<div data-component="Card" className={wrapperCardStyle}>
				<Link className={wrapperLinkStyle} to={to}>
					<article className={wrapperStyle(background, hasVideo, date || views)}>
						<div className={wrapperInnerStyle}>
							<div className={metaAudiencesStyle}>
								{audiences.map(audience => (
									<AudienceIcon key={audience.id} audience={audience} size={12} />
								))}
							</div>

							<h1 className={titleStyle}>{title}</h1>

							<p className={bodyStyle}>{body}</p>
						</div>

						{(date || views) && (
							<div className={metaBottomStyle}>
								{date && <p className={metaDateStyle}>{format(date)}</p>}
								{views && (
									<p className={metaViewsStyle}>
										<ViewsIcon /> {views}
									</p>
								)}
							</div>
						)}
					</article>
				</Link>
				<span className={bookmarkButtonStyle(!!background)}>
					<BookmarkIcon
						fill={background ? '#fff' : undefined}
						bookmarkableContent={this.props}
						bookmarkType={type}
					/>
				</span>
			</div>
		);
	}
}

ResourceCardComponent.defaultProps = {
	type: 'resource',
};

ResourceCardComponent.propTypes = {
	type: PropTypes.string,
	to: PropTypes.string,
	audiences: PropTypes.array,
	title: PropTypes.string,
	body: PropTypes.string,
	date: PropTypes.string,
	views: PropTypes.number,
	background: PropTypes.string,
	hasVideo: PropTypes.bool,
};

export const ResourceCard = ResourceCardComponent;



// WEBPACK FOOTER //
// ./src/components/shared/cards/resourceCard/component.js